import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';

import { downloadExcel, downloadSettingExcel } from "src/utils/blob/blobUtil";

import { calculateLotQty, defaultKSK2020_R01Filter, KSK2020_R01Filter, recalculateDetailListWithTransport, useKSK2020_R01Store } from './Store_KSK2020_R01';
import useFetchActionbarAuth from 'src/hooks/useFetchActionbarAuth';
import useUiuxStore, { Tab } from 'src/store/useUiuxStore';
import { useLoadingSpinnerStore } from 'src/store/util/loadingSpinnerUtil';
import { showError, showSuccess, ShowSuccessFetch, showWarning } from 'src/utils/toast/toastUtil';

import { deleteKSK2020_R01, deleteKSK2020_R01Inspect, downloadExcel_KSK2020_R01, getKSK2020_R01AllCount, getKSK2020_R01LotList, getKSK2020_R01InspectList, getKSK2020_R01List, getKSK2020_R01ProductResultList, patchKSK2020_R01, postKSK2020_R01, postKSK2020_R01Inspect, postKSK2020_R01StockLot, printKSK2020_R01, getKSK2020_R01DetailList, getKSK2020_R01DetailStockList, getKSK2020_R01TransportedInfo, getKSK2020_R01One, getKSK2020_R01StockLot, createKSK2020_R01LotNo, getKSK2020_R01LotCountOne, patchKSK2020_R01LotCount, patchKSK2020_R01LotCountReset } from "./Api_KSK2020_R01";
import { defaultKSK2020_R01LotDto, defaultKSK2020_R01HeaderDto, defaultKSK2020_R01InspectDto, KSK2020_R01LotDto, KSK2020_R01Dto, KSK2020_R01HeaderDto, KSK2020_R01InspectDto, KSK2020_R01ProductResultDto, defaultKSK2020_R01DetailDto, KSK2020_R01DetailDto, KSK2020_R01WorkTimeProcessType } from './Dto_KSK2020_R01';
import { AgGridReact } from 'ag-grid-react';
import { fetchDataSetHandler, fetchFilterConfig, gridRefSelectedRowHandler } from 'src/utils/grid/GridHandlerContent';
import { CompanyDto } from 'src/dtos/company/companyDto';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';
import { useCommonCodeValidate } from 'src/utils/commonCode/CommonCodeValidateContext';
import {
	buildCommonCodeRequirements,
	KSK2020_R01_BAD_WAREHOUSE_MESSAGE,
	KSK2020_R01_HEADER_ROW_VALIDATE,
	KSK2020_R01_INSPECT_ROW_VALIDATE,
	KSK2020_R01_LOT_ROW_VALIDATE,
	KSK2020_R01_OUT_WAREHOUSE_MESSAGE,
	KSK2020_R01_PRODUCT_WAREHOUSE_MESSAGE,
} from 'src/utils/commonCode/commonCodeRequirementConfig';
import { formatDate, toLocalDateTime, validateString } from 'src/utils/string/stringUtil';
import { validateEmployeeCd } from 'src/utils/grid/GridValidateContent';
import { defaultValidateDateString } from 'src/components/common/common';
import { isUnsetWorkDateTime } from 'src/utils/date/dateUtils';
import { AxiosError } from 'axios';
import { InfoCodeSearchFieldConfig } from 'src/types/info-form';
import { getProductOrderPopupList } from 'src/apis/productOrderApi';
import { getProductResultPopupList } from 'src/apis/productResultApi';
import { useInfoFormEvents } from 'src/hooks/useInfoFormEvents';
import useUserStore from 'src/store/useUserStore';
import { useQzPrint } from 'src/hooks/useQzPrint';
import { KSK2020_R01_buildLabelData } from './util/labelDataBuilder_KSK2020_R01';
import { aggregateInspectListByBadCase, validateEditBadQtyAgainstInspectList } from './util/inspectBadQtyUtil_KSK2020_R01';

interface Props {
	gridRef: React.RefObject<AgGridReact<KSK2020_R01HeaderDto> | null>;
	lotGridRef: React.RefObject<AgGridReact<KSK2020_R01LotDto> | null>;
	detailGridRef: React.RefObject<AgGridReact<KSK2020_R01DetailDto> | null>;
	inspectGridRef: React.RefObject<AgGridReact<KSK2020_R01InspectDto> | null>;

	tabList: Tab[] | undefined;
	setMessage: (message: string) => void;

	containerRef: React.RefObject<HTMLDivElement | null>;
	isResizing: React.MutableRefObject<boolean>;
	
}



export const Content_KSK2020_R01 = (props: Props) => {

	const {
		gridRef, lotGridRef, detailGridRef, inspectGridRef,
		tabList, setMessage,
		containerRef,
		isResizing,
	} = props;

	const { faultyValueList, itemStatusList, moneyCdList, vatTypeList, compCdList, wmsCdList, employeeCdList, workPlaceList, warehouseCdList, itemCdMap } = useCommonCodeStore();
	const { validateCommonCodeLists } = useCommonCodeValidate();
	const { productWorkNavigationData, setProductWorkNavigationData, setOrderNavigationData, addTabList, setActiveTab } = useUiuxStore();

	
	const {
		KSK2020_R01Filter, setKSK2020_R01Filter,
		KSK2020_R01PastFilter, setKSK2020_R01PastFilter,
		KSK2020_R01List, setKSK2020_R01List,
		editKSK2020_R01, setEditKSK2020_R01,
		// selectedKSK2020_R01, setSelectedKSK2020_R01, 
		deletedKSK2020_R01LotList, setDeletedKSK2020_R01LotList, addDeletedKSK2020_R01LotList, removeDeletedKSK2020_R01LotList, 
		selectedKSK2020_R01LotList, setSelectedKSK2020_R01LotList, addSelectedKSK2020_R01LotList, removeSelectedKSK2020_R01LotList,
		KSK2020_R01LotList, setKSK2020_R01LotList, insertKSK2020_R01LotList,
		originalKSK2020_R01LotList, setOriginalKSK2020_R01LotList,
		deletedKSK2020_R01DetailList, setDeletedKSK2020_R01DetailList, addDeletedKSK2020_R01DetailList, removeDeletedKSK2020_R01DetailList, 
		selectedKSK2020_R01DetailList, setSelectedKSK2020_R01DetailList, addSelectedKSK2020_R01DetailList, removeSelectedKSK2020_R01DetailList,
		KSK2020_R01DetailList, setKSK2020_R01DetailList, insertKSK2020_R01DetailList,
		originalKSK2020_R01DetailList, setOriginalKSK2020_R01DetailList,
		KSK2020_R01InspectList, setKSK2020_R01InspectList, insertKSK2020_R01InspectList, removeKSK2020_R01InspectList,
		deletedKSK2020_R01InspectList, setDeletedKSK2020_R01InspectList, addDeletedKSK2020_R01InspectList, removeDeletedKSK2020_R01InspectList,
		selectedKSK2020_R01InspectList, setSelectedKSK2020_R01InspectList, addSelectedKSK2020_R01InspectList, removeSelectedKSK2020_R01InspectList,
		originalKSK2020_R01InspectList, setOriginalKSK2020_R01InspectList,
		allCount, setAllCount,
		notProductResult, setNotProductResult,
		initKSK2020_R01LotData,
		modalVisible, setModalVisible,
		workTimeModalVisible, setWorkTimeModalVisible,
		workTimeModalType, setWorkTimeModalType,
		initData, 
		warehouseCdListToUseList, outWarehouseCdListToUseList, badWarehouseCdListToUseList,
	} = useKSK2020_R01Store();
	const { setLoadingSpinner } = useLoadingSpinnerStore();
	const { setCodeSearchModalProps } = useUiuxStore();
	const { company, userInfo } = useUserStore();
	const { printBulkLabel } = useQzPrint();

	type ProductOrderNav = { productOrderNo: string; productWorkNo?: string } | null;
	const navigationDataRef = useRef<ProductOrderNav>(null);
	const [productWorkTrigger, setProductWorkTrigger] = useState(false);
	const [isLotCountResetting, setIsLotCountResetting] = useState(false);
	const handleFetchProductResultRef = useRef<(() => Promise<void>) | null>(null);
	const isFetchingProductResultRef = useRef(false);
	const lotCountAdjustmentPendingRef = useRef(0);
	const lotCountAdjustmentVersionRef = useRef(0);
	const lotCountAdjustmentErrorRef = useRef<string | null>(null);
	const isLotCountPollingRef = useRef(false);
	const isLotCountResettingRef = useRef(false);

	// 기존: productWorkInfoHandleFoucsId / 공정지시
	const productOrderInfoHandleFocusId = 'inputProductOrderNo_search';
	const productResultInfoHandleFocusId = 'inputProductResultNo_search';

	useFetchActionbarAuth("KSK2020_R01");

	// 기존: productWorkNo(공정지시) 설정 + productOrderNo를 productWorkNo에 매핑
	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'productOrderNo',
			category: '작업지시번호',
			focusId: productOrderInfoHandleFocusId,
			preserveExtraFilterOnReset: true,
			responseMapping: {
				productOrderNo: 'productOrderNo',
			},
			searchFunction: async (code: string) => {
				const productOrderResponse = await getProductOrderPopupList(
					code,
					userInfo?.compCd || '',
					userInfo?.workplaceCd || '',
					'',
				);
				return productOrderResponse.data.data.find(value => value.productOrderNo === code);
			},
			extraFilter: () => ({
				compCd: userInfo?.compCd || '',
				workplaceCd: userInfo?.workplaceCd || '',
				closeTag: '',
			}),
			onAfterConfirm: () => {
				setProductWorkTrigger(true);
			},
		},
		{
			fieldName: 'productResultNo',
			category: '생산실적',
			focusId: productResultInfoHandleFocusId,
			preserveExtraFilterOnReset: true,
			responseMapping: {
				productResultNo: 'productResultNo',
				productOrderNo: 'productOrderNo',
			},
			searchFunction: async (code: string) => {
				const productResultResponse = await getProductResultPopupList(code, {
					productOrderNo: editKSK2020_R01?.productOrderNo || '',
					compCd: userInfo?.compCd || '',
					workplaceCd: userInfo?.workplaceCd || '',
				});
				return productResultResponse.data.data.find(value => value.productResultNo === code);
			},
			extraFilter: () => ({
				productOrderNo: editKSK2020_R01?.productOrderNo || '',
				compCd: userInfo?.compCd || '',
				workplaceCd: userInfo?.workplaceCd || '',
			}),
			onAfterConfirm: () => {
				void handleFetchProductResultRef.current?.();
			},
		},
	];

	const handlePrintClick = async () => {
		if (!editKSK2020_R01 || !editKSK2020_R01.productOrderNo) {
				showWarning("출력할 생산실적번호를 선택하세요.");
				setMessage("출력할 생산실적번호를 선택하세요.");
				return;
			}
			try {
				await printKSK2020_R01(editKSK2020_R01.productOrderNo);
			} catch (error) {
				setMessage("PDF 출력 중 오류가 발생했습니다.");
			}
		};
	

	const handleExcelClick = useCallback(async () => {
		if (!editKSK2020_R01) {
			showWarning("선택된 생산실적내역이 없습니다.");
			return;
		}
		setLoadingSpinner(true);

		const response = await downloadExcel_KSK2020_R01('', editKSK2020_R01.productOrderNo, KSK2020_R01List.length ?? 0);

		downloadSettingExcel({ responseData: response.data.data, fileName: '생산실적 등록-excel.xlsx' });

		setLoadingSpinner(false);
	}, [editKSK2020_R01])

	const getParams = (filter: KSK2020_R01Filter) => {
		const params: Partial<KSK2020_R01Filter> = {
			labelPrintAuto: filter.labelPrintAuto || undefined,
		};
		return params;
	}

	// const renewalAllCount = useCallback(async () => {
	// 	const response = await getKSK2020_R01AllCount(getParams(KSK2020_R01Filter));
	// 	setAllCount(response.data.data);
	// 	return response.data.data;
	// }, [KSK2020_R01Filter, setAllCount]);

	// const fetchData = useCallback(async () => {
	// 	setLoadingSpinner(true);		
	
	// 	const responseData = (await getKSK2020_R01List(
	// 		'',
	// 		getParams(KSK2020_R01Filter),
	// 		KSK2020_R01List.length ?? 0
	// 	));


	// 	let newList = [...responseData.data.data ] as KSK2020_R01HeaderDto[];
	// 	setKSK2020_R01List(newList);

	// 	const processAllCount = await renewalAllCount();
	// 	if (newList && newList.length > 0) {
	// 		gridRefSelectedRowHandler(
	// 			gridRef,
	// 			setEditKSK2020_R01 || undefined,
	// 			() => true,// () => !responseData.find(value => value.salBillNo === selectedKSK2020_R01?.salBillNo)
	// 		);
	// 		setKSK2020_R01PastFilter(KSK2020_R01Filter);
	// 		ShowSuccessFetch(setMessage, `조회가 완료되었습니다. (총 ${newList.length}/${processAllCount}건)`);
	// 	}else {
	// 		showWarning('데이터가 없습니다.');
	// 		setSelectedKSK2020_R01(undefined);
	// 		setKSK2020_R01List([]);
	// 		setKSK2020_R01LotList([]); 
	// 		setDeletedKSK2020_R01LotList([]);
	// 		setSelectedKSK2020_R01LotList([]);
	// 		setOriginalKSK2020_R01LotList([]);
	// 	}
	// 	setLoadingSpinner(false);
	// 	return responseData;
	// }, [KSK2020_R01Filter, KSK2020_R01List, setKSK2020_R01List, setKSK2020_R01PastFilter, setSelectedKSK2020_R01, selectedKSK2020_R01])

	const resolveQtyAfterLotIssue = (
		prevEdit: KSK2020_R01HeaderDto,
		responseOrderHeader: KSK2020_R01HeaderDto,
		issuedQty: number,
	) => {
		const prevResultQty = Number(prevEdit.resultQty) || 0;
		const responseResultQty = Number(responseOrderHeader.resultQty) || 0;
		const newResultQty = responseResultQty > prevResultQty
			? responseResultQty
			: prevResultQty + issuedQty;
		const newOrderQtyView = Math.max(0, (Number(prevEdit.orderQtyView) || 0) - issuedQty);
		return {
			resultQty: newResultQty,
			productQty: newResultQty,
			orderQtyView: newOrderQtyView,
		};
	};

	const fetchOne = useCallback(async () => {
		if (!editKSK2020_R01?.productOrderNo) { 
			showWarning('조회할 작업지시번호를 선택하세요.'); 
			getProductWorkFieldHandlers('productOrderNo')
				.onDoubleClick({ currentTarget: { blur: () => {}, value: '' } } as unknown as React.MouseEvent<HTMLInputElement>);
			return; 
		}
		setLoadingSpinner(true);

		const response = await getKSK2020_R01One(editKSK2020_R01?.productOrderNo || '');
		
		if(!response.data.data) {
			showWarning('조회된 데이터가 없습니다.');
			getProductWorkFieldHandlers('productOrderNo')
				.onDoubleClick({ currentTarget: { blur: () => {}, value: editKSK2020_R01?.productOrderNo } } as unknown as React.MouseEvent<HTMLInputElement>);
			setLoadingSpinner(false);
			return;
		}

		const workPlaceInfo = workPlaceList.find(value => value.workplaceCd === response.data.data?.workplaceCd);

		let logicCenter = wmsCdList.filter(value => value.minorCd === workPlaceInfo?.logicCenter)[0].minorCd;
		let defaultInWarehouseCd = warehouseCdList.filter(value => value.logicCenter === logicCenter
			&& (value.productYn === 'Y' || value.manufactYn === 'Y' )
		);
		let defaultOutWarehouseCd = warehouseCdList.filter(value => value.logicCenter === logicCenter
			&& (value.materialYn === 'Y' || value.manufactYn === 'Y' )
		);
		let defaultBadWarehouseCd = warehouseCdList.filter(value => value.logicCenter === logicCenter
			&& value.badYn === 'Y'
		);
		let inWarehouseCd = defaultInWarehouseCd.filter(value => (value.warehouseCd === workPlaceInfo?.inWarehouse));
		let outWarehouseCd = defaultOutWarehouseCd.filter(value => (value.warehouseCd === workPlaceInfo?.outWarehouse));
		let badWarehouseCd = defaultBadWarehouseCd.filter(value => (value.warehouseCd === workPlaceInfo?.badWarehouse));

		// console.log('작업지시정보의 logicCenter :', logicCenter);
		// console.log('작업지시정보의 inWarehouseCd :', inWarehouseCd, ' > ', '작업지시정보의 outWarehouseCd :', outWarehouseCd);

		response.data.data.logicCenter = logicCenter || wmsCdList[0]?.minorCd || '';
		response.data.data.warehouseCd = validateString(response.data.data.warehouseCd) ? response.data.data.warehouseCd : (inWarehouseCd[0]?.warehouseCd ?? '');
		response.data.data.outWarehouseCd = validateString(response.data.data.outWarehouseCd) ? response.data.data.outWarehouseCd : (outWarehouseCd[0]?.warehouseCd ?? '');
		response.data.data.badWarehouseCd = validateString(response.data.data.badWarehouseCd) ? response.data.data.badWarehouseCd : (badWarehouseCd[0]?.warehouseCd ?? '');

		let currentLotQty = 0;
		if (validateString(response.data.data.workplaceCd)) {
			try {
				const lotCountResponse = await getKSK2020_R01LotCountOne(response.data.data.workplaceCd);
				currentLotQty = Number(lotCountResponse.data.data?.pendingLotQty) || 0;
			} catch (error) {
				console.error('LOT 현재 생산수량 조회 실패:', error);
			}
		}

		// 작업지시 재조회 시 이전 실적/작업시간 등 잔여값 초기화
		const resetWorkTime = defaultValidateDateString.replace(' ', 'T');
		const resultQty = Number(response.data.data.resultQty) || 0;
		const fullOrderQty = Number(response.data.data.orderQty) || 0;
		const mappedHeader: KSK2020_R01HeaderDto = {
			...response.data.data,
			productDt: formatDate(new Date()),
			resultQty,
			productQty: resultQty,
			orderQty: fullOrderQty,
			orderQtyView: Math.max(0, fullOrderQty - resultQty),
			productResultNo: '',
			pendingLotQty: 0,
			badQty: 0,
			acceptQty: 0,
			plcCount: currentLotQty,
			workStartDt: resetWorkTime,
			workEndDt: resetWorkTime,
			timeParam: toLocalDateTime(new Date()),
		};
		setEditKSK2020_R01(mappedHeader);
		setNotProductResult(true);

		setLoadingSpinner(false);
		return mappedHeader as KSK2020_R01HeaderDto;
	}, [editKSK2020_R01, setEditKSK2020_R01, setLoadingSpinner, setNotProductResult, workPlaceList, wmsCdList, warehouseCdList]);

	const fetchDetailList = useCallback(async (
		productOrderNo: string,
		itemCd: string,
		productQty: number,
		badQty: number,
		outWarehouseCd: string,
		logicCenter: string,
		workPlaceCd: string,
	) => {
		try {
			const response = await getKSK2020_R01DetailList(productOrderNo, itemCd, productQty, badQty, outWarehouseCd, logicCenter, workPlaceCd);

			if (response.data && response.data.successFlag === false) {
				setKSK2020_R01DetailList([]);
				return;
			}

			const responseData = response.data.data;
			if (responseData && responseData.length > 0) {
				const updatedDetailList = responseData.map((value, idx) => ({
					...value,
					valueIndex: value.valueIndex ?? idx + 1,
					orderIndex: value.orderIndex ?? idx + 1,
					orderIndexSeq: value.orderIndexSeq ?? 0,
					lotQty: value.lotQty ?? 0,
					transportQty: 0,
					transportedQty: 0,
				}));
				setKSK2020_R01DetailList(updatedDetailList);
				setOriginalKSK2020_R01DetailList(responseData);
				detailGridRef.current?.api.ensureIndexVisible(0, 'top');
				setTimeout(() => setMessage(""), 5000);
			} else {
				setKSK2020_R01DetailList([]);
			}
		} catch (error) {
			console.error(error);
			setKSK2020_R01DetailList([]);
		}
	}, [setKSK2020_R01DetailList, setOriginalKSK2020_R01DetailList, setMessage]);
	

	const defaultKSK2020_R01HeaderRow = useCallback(() => {
		const logicCenter = wmsCdList[0]?.minorCd ?? '';
		const warehouseCdListToUse = warehouseCdListToUseList(logicCenter);
		const outWarehouseCdListToUse = outWarehouseCdListToUseList(logicCenter);
		const badWarehouseCdListToUse = badWarehouseCdListToUseList(logicCenter);

		const commonResult = validateCommonCodeLists([
			...buildCommonCodeRequirements(KSK2020_R01_HEADER_ROW_VALIDATE, {
				compCdList,
				workPlaceList,
				wmsCdList,
				itemStatusList,
				warehouseCdList,
			}),
			{
				key: 'productWarehouseList',
				list: warehouseCdListToUse,
				message: KSK2020_R01_PRODUCT_WAREHOUSE_MESSAGE,
			},
			{
				key: 'outWarehouseList',
				list: outWarehouseCdListToUse,
				message: KSK2020_R01_OUT_WAREHOUSE_MESSAGE,
			},
			{
				key: 'badWarehouseList',
				list: badWarehouseCdListToUse,
				message: KSK2020_R01_BAD_WAREHOUSE_MESSAGE,
			},
		]);

		if (!commonResult.valid) {
			return {
				...defaultKSK2020_R01HeaderDto,
				inserted: true,
			};
		}

		return {
			...defaultKSK2020_R01HeaderDto,
			compCd: compCdList[0].compCd,
			workplaceCd: workPlaceList[0].workplaceCd,
			logicCenter,
			warehouseCd: warehouseCdListToUse[0].warehouseCd,
			outWarehouseCd: outWarehouseCdListToUse[0].warehouseCd,
			badWarehouseCd: badWarehouseCdListToUse[0].warehouseCd,
			itemStatus: itemStatusList[0].minorCd,
			inserted: true,
		};
	}, [
		compCdList,
		workPlaceList,
		wmsCdList,
		itemStatusList,
		warehouseCdList,
		warehouseCdListToUseList,
		outWarehouseCdListToUseList,
		badWarehouseCdListToUseList,
		validateCommonCodeLists,
	]);

	const defaultKSK2020_R01LotRow = useCallback(() => {
		const commonResult = validateCommonCodeLists(
			buildCommonCodeRequirements(KSK2020_R01_LOT_ROW_VALIDATE, { itemStatusList }),
		);

		if (!commonResult.valid) {
			return {
				...defaultKSK2020_R01LotDto,
				inserted: true,
			};
		}

		return {
			...defaultKSK2020_R01LotDto,
			itemStatus: itemStatusList[0].minorCd,
			inserted: true,
		};
	}, [itemStatusList, validateCommonCodeLists]);

	const defaultKSK2020_R01DetailRow = useCallback(() => ({
		...defaultKSK2020_R01DetailDto,
		inserted: true,
	}), [defaultKSK2020_R01DetailDto]);

	const defaultKSK2020_R01InspectRow = useCallback(() => {
		const commonResult = validateCommonCodeLists(
			buildCommonCodeRequirements(KSK2020_R01_INSPECT_ROW_VALIDATE, { faultyValueList }),
		);

		if (!commonResult.valid) {
			return {
				...defaultKSK2020_R01InspectDto,
				inserted: true,
			};
		}

		return {
			...defaultKSK2020_R01InspectDto,
			badCase: faultyValueList[0].minorCd,
			inserted: true,
		};
	}, [faultyValueList, validateCommonCodeLists]);

	const resetToWorkOrderInitialState = useCallback(async (): Promise<boolean> => {
		if (!validateString(editKSK2020_R01?.productOrderNo || '')) {
			return false;
		}

		setKSK2020_R01LotList([]);
		setKSK2020_R01DetailList([]);
		setKSK2020_R01InspectList([]);
		setDeletedKSK2020_R01LotList([]);
		setSelectedKSK2020_R01LotList([]);
		setOriginalKSK2020_R01LotList([]);
		setDeletedKSK2020_R01InspectList([]);
		setSelectedKSK2020_R01InspectList([]);
		setOriginalKSK2020_R01InspectList([]);

		const headerData = await fetchOne();
		if (!headerData) {
			return false;
		}

		await fetchDetailList(
			headerData.productOrderNo || '',
			headerData.itemCd || '',
			0,
			0,
			headerData.outWarehouseCd,
			headerData.logicCenter,
			headerData.workplaceCd,
		);

		initKSK2020_R01LotData();
		setKSK2020_R01InspectList([]);
		insertKSK2020_R01InspectList([defaultKSK2020_R01InspectRow()]);

		const latestEdit = useKSK2020_R01Store.getState().editKSK2020_R01;
		if (latestEdit) {
			const resetWorkTime = defaultValidateDateString.replace(' ', 'T');
			setEditKSK2020_R01({
				...latestEdit,
				productResultNo: '',
				productDt: formatDate(new Date()),
				pendingLotQty: 0,
				badQty: 0,
				workStartDt: resetWorkTime,
				workEndDt: resetWorkTime,
			});
		}
		setNotProductResult(true);
		return true;
	}, [
		defaultKSK2020_R01InspectRow,
		editKSK2020_R01?.productOrderNo,
		fetchDetailList,
		fetchOne,
		initKSK2020_R01LotData,
		insertKSK2020_R01InspectList,
		setDeletedKSK2020_R01InspectList,
		setDeletedKSK2020_R01LotList,
		setEditKSK2020_R01,
		setKSK2020_R01DetailList,
		setKSK2020_R01InspectList,
		setKSK2020_R01LotList,
		setNotProductResult,
		setOriginalKSK2020_R01InspectList,
		setOriginalKSK2020_R01LotList,
		setSelectedKSK2020_R01InspectList,
		setSelectedKSK2020_R01LotList,
	]);
	
	const initContainerData = useCallback(() => {
		initData();
		removeDeletedKSK2020_R01LotList();
		removeSelectedKSK2020_R01LotList();
		setEditKSK2020_R01(defaultKSK2020_R01HeaderRow());
		//라벨자동출력 옵션을 사업자정보에 있는 것과 동일하게 처리
		setKSK2020_R01Filter({ ...KSK2020_R01Filter, labelPrintAuto: company?.labelPrintAuto || 'N' });
	}, [company, defaultKSK2020_R01HeaderRow, initData, KSK2020_R01Filter, removeDeletedKSK2020_R01LotList, removeSelectedKSK2020_R01LotList, setEditKSK2020_R01, setKSK2020_R01Filter]);

	const handleWorkResetClick = useCallback(() => {
		lotCountAdjustmentVersionRef.current += 1;
		lotCountAdjustmentErrorRef.current = null;

		lotGridRef.current?.api.stopEditing();
		inspectGridRef.current?.api.stopEditing();
		lotGridRef.current?.api.deselectAll();
		inspectGridRef.current?.api.deselectAll();

		const currentEdit = useKSK2020_R01Store.getState().editKSK2020_R01;
		if (currentEdit) {
			setEditKSK2020_R01({
				...currentEdit,
				productResultNo: '',
				productDt: formatDate(new Date()),
				jobTeam: '',
				productEmp: '',
				productEmpNm: '',
				pendingLotQty: 0,
				badQty: 0,
				acceptQty: 0,
				workStartDt: undefined,
				workEndDt: undefined,
			});
		}

		initKSK2020_R01LotData();
		setKSK2020_R01InspectList([]);
		setDeletedKSK2020_R01InspectList([]);
		setSelectedKSK2020_R01InspectList([]);
		setOriginalKSK2020_R01InspectList([]);
		setModalVisible(false);
		setWorkTimeModalVisible(false);
		setWorkTimeModalType(null);
		setNotProductResult(true);
		setMessage('');
	}, [
		initKSK2020_R01LotData,
		inspectGridRef,
		lotGridRef,
		setDeletedKSK2020_R01InspectList,
		setEditKSK2020_R01,
		setKSK2020_R01InspectList,
		setMessage,
		setModalVisible,
		setNotProductResult,
		setOriginalKSK2020_R01InspectList,
		setSelectedKSK2020_R01InspectList,
		setWorkTimeModalType,
		setWorkTimeModalVisible,
	]);

	const handleDeleteClick = useCallback(() => {
		if (deletedKSK2020_R01InspectList.length > 0) {
			removeDeletedKSK2020_R01InspectList(deletedKSK2020_R01InspectList);
			removeSelectedKSK2020_R01InspectList();
			setKSK2020_R01InspectList([...KSK2020_R01InspectList]);
		} else if (selectedKSK2020_R01InspectList.length > 0) {
			addDeletedKSK2020_R01InspectList(selectedKSK2020_R01InspectList);
			removeSelectedKSK2020_R01InspectList(selectedKSK2020_R01InspectList);
		}
	}, [
		selectedKSK2020_R01InspectList, deletedKSK2020_R01InspectList, setKSK2020_R01InspectList, KSK2020_R01InspectList,
		removeDeletedKSK2020_R01InspectList, removeSelectedKSK2020_R01InspectList, addDeletedKSK2020_R01InspectList,
	]);
	
	const handleCreateClick = () => {
		setEditKSK2020_R01(defaultKSK2020_R01HeaderRow());

		setKSK2020_R01LotList([]);
		setDeletedKSK2020_R01LotList([]);
		setSelectedKSK2020_R01LotList([]);

		setKSK2020_R01InspectList([defaultKSK2020_R01InspectRow()]);
		setDeletedKSK2020_R01InspectList([]);
		setSelectedKSK2020_R01InspectList([]);
		setOriginalKSK2020_R01InspectList([]);
	}

	/** 생산일자 — 유효하지 않으면 당일 */
	const resolveKSK2020_R01ProductDt = (
		header?: Pick<KSK2020_R01HeaderDto, 'productDt'> | null,
		fallback?: string,
	): string => {
		if (header?.productDt) {
			const parsed = new Date(header.productDt);
			if (!Number.isNaN(parsed.getTime())) {
				return formatDate(parsed);
			}
		}
		return fallback ?? formatDate(new Date());
	};

	const getProductResultHeaderDto = (header: KSK2020_R01HeaderDto) => {
		const productDt = resolveKSK2020_R01ProductDt(header);
		return {
			...header,
			productDt,
			kpiYn: 'N',
			productEmp: header.productEmp || header.orderEmp,
			productEmpNm: header.productEmpNm || header.orderEmpNm,
			badWarehouseCd: header.badWarehouseCd,
			inspectQty: 0,
			inspectYn: 'N',
		} as KSK2020_R01ProductResultDto;
	}

	const refreshInspectListFromServer = useCallback(async (productResultNo: string) => {
		const inspectResponse = await getKSK2020_R01InspectList(productResultNo);
		const inspectList = inspectResponse.data.data ?? [];

		setDeletedKSK2020_R01InspectList([]);
		setSelectedKSK2020_R01InspectList([]);

		if (inspectList.length > 0) {
			setKSK2020_R01InspectList([]);
			insertKSK2020_R01InspectList(inspectList);
			setOriginalKSK2020_R01InspectList(inspectList);
		} else {
			setKSK2020_R01InspectList([defaultKSK2020_R01InspectRow()]);
			setOriginalKSK2020_R01InspectList([]);
		}

		// ResultInfo 생산불량수량 — inspect 목록 badQty 합계로 반영
		const { totalQty } = aggregateInspectListByBadCase(inspectList);
		const latestEdit = useKSK2020_R01Store.getState().editKSK2020_R01;
		if (latestEdit) {
			setEditKSK2020_R01({ ...latestEdit, badQty: totalQty });
		}
	}, [
		defaultKSK2020_R01InspectRow,
		insertKSK2020_R01InspectList,
		setDeletedKSK2020_R01InspectList,
		setEditKSK2020_R01,
		setKSK2020_R01InspectList,
		setOriginalKSK2020_R01InspectList,
		setSelectedKSK2020_R01InspectList,
	]);

	const validateInspectModalData = useCallback(() => {
		if (!editKSK2020_R01 || !validateString(editKSK2020_R01.productResultNo)) {
			showWarning('생산실적코드를 입력하세요.');
			return false;
		}

		const deletedInspectListToNumber = deletedKSK2020_R01InspectList.map(value => Number(value));
		const badQtyValidation = validateEditBadQtyAgainstInspectList(
			editKSK2020_R01.badQty || 0,
			KSK2020_R01InspectList,
			deletedInspectListToNumber,
		);
		if (!badQtyValidation.valid) {
			showWarning(badQtyValidation.message!);
			return false;
		}

		const activeInspectList = KSK2020_R01InspectList.filter(inspect =>
			!deletedInspectListToNumber.includes(inspect.valueIndex),
		);
		const badCases = activeInspectList.map(detail => detail.badCase).filter(badCase => badCase);
		const duplicates = badCases.filter((badCase, index) => badCases.indexOf(badCase) !== index);
		if (duplicates.length > 0) {
			const badCaseNames = duplicates.map(badCase => faultyValueList.find(value => value.minorCd === badCase)?.codeNm);
			showWarning('중복된 불량사유가 있습니다.\n불량사유: ' + badCaseNames.join(', '));
			return false;
		}

		return true;
	}, [
		deletedKSK2020_R01InspectList,
		editKSK2020_R01,
		faultyValueList,
		KSK2020_R01InspectList,
	]);

	const handleInspectConfirmClick = useCallback(async () => {
		if (!validateInspectModalData()) return;

		const insertInspectList = KSK2020_R01InspectList.filter(row =>
			row.inserted === true && validateString(row.badCase),
		);
		if (insertInspectList.length === 0) {
			showWarning('등록할 불량내역이 없습니다. (행+ 버튼으로 추가한 행만 등록됩니다.)');
			return;
		}

		setLoadingSpinner(true);
		try {
			const response = await postKSK2020_R01Inspect({
				productOrderHeaderDto: editKSK2020_R01!,
				productResultHeaderDto: {
					...getProductResultHeaderDto(editKSK2020_R01!),
					badQty: editKSK2020_R01!.badQty ?? 0,
				},
				wmsStockLotDtoList: [],
				bomDtoList: [],
				prdInspectResultDtoList: insertInspectList,
			});

			if (!response.data?.successFlag) {
				showWarning('불량내역 등록에 실패하였습니다.');
				return;
			}

			const responseData = response.data.data;
			setEditKSK2020_R01({
				...editKSK2020_R01!,
				badQty: responseData.productResultHeaderDto?.badQty ?? editKSK2020_R01!.badQty ?? 0,
			});

			await refreshInspectListFromServer(editKSK2020_R01!.productResultNo);
			showSuccess('불량내역 등록이 완료되었습니다.');
			setMessage('불량내역 등록이 완료되었습니다.');
			setModalVisible(false);
		} catch (error) {
			console.error('불량내역 등록 중 오류가 발생했습니다.:', error);
			const serverMessage = (error as AxiosError<{ message: string }>)?.response?.data?.message;
			showWarning(serverMessage || '불량내역 등록 중 오류가 발생하였습니다.');
		} finally {
			setLoadingSpinner(false);
		}
	}, [
		editKSK2020_R01,
		KSK2020_R01InspectList,
		refreshInspectListFromServer,
		setEditKSK2020_R01,
		setLoadingSpinner,
		setMessage,
		setModalVisible,
		validateInspectModalData,
	]);

	const handleInspectDeleteClick = useCallback(async () => {
		if (deletedKSK2020_R01InspectList.length > 0) {
			removeDeletedKSK2020_R01InspectList(deletedKSK2020_R01InspectList);
			removeSelectedKSK2020_R01InspectList();
			setKSK2020_R01InspectList([...KSK2020_R01InspectList]);
			return;
		}

		if (selectedKSK2020_R01InspectList.length === 0) {
			showWarning('삭제할 불량내역을 선택하세요.');
			return;
		}

		const selectedRows = KSK2020_R01InspectList.filter(row =>
			selectedKSK2020_R01InspectList.includes(String(row.valueIndex)),
		);
		const serverDeleteRows = selectedRows.filter(row => validateString(row.inspectNo));
		const localInsertRows = selectedRows.filter(row => row.inserted === true && !validateString(row.inspectNo));

		if (serverDeleteRows.length === 0 && localInsertRows.length === 0) {
			showWarning('삭제할 불량내역이 없습니다.');
			return;
		}

		setLoadingSpinner(true);
		try {
			if (serverDeleteRows.length > 0) {
				if (!editKSK2020_R01 || !validateString(editKSK2020_R01.productResultNo)) {
					showWarning('생산실적코드를 입력하세요.');
					return;
				}

				const deleteResponse = await deleteKSK2020_R01Inspect({
					productOrderHeaderDto: editKSK2020_R01,
					productResultHeaderDto: getProductResultHeaderDto(editKSK2020_R01),
					wmsStockLotDtoList: [],
					bomDtoList: [],
					prdInspectResultDtoList: serverDeleteRows,
				});

				if (!deleteResponse.data?.successFlag) {
					showWarning('불량내역 삭제에 실패하였습니다.');
					return;
				}

				await refreshInspectListFromServer(editKSK2020_R01.productResultNo);
				showSuccess('불량내역 삭제가 완료되었습니다.');
				setMessage('불량내역 삭제가 완료되었습니다.');
			}

			localInsertRows.forEach(row => {
				removeKSK2020_R01InspectList(row.valueIndex);
			});
			removeSelectedKSK2020_R01InspectList(selectedKSK2020_R01InspectList);
		} catch (error) {
			console.error('불량내역 삭제 중 오류가 발생했습니다.:', error);
			const serverMessage = (error as AxiosError<{ message: string }>)?.response?.data?.message;
			showWarning(serverMessage || '불량내역 삭제 중 오류가 발생하였습니다.');
		} finally {
			setLoadingSpinner(false);
		}
	}, [
		deletedKSK2020_R01InspectList,
		editKSK2020_R01,
		KSK2020_R01InspectList,
		refreshInspectListFromServer,
		removeDeletedKSK2020_R01InspectList,
		removeKSK2020_R01InspectList,
		removeSelectedKSK2020_R01InspectList,
		selectedKSK2020_R01InspectList,
		setKSK2020_R01InspectList,
		setLoadingSpinner,
		setMessage,
	]);

	const validateInsertData = (
		header: KSK2020_R01HeaderDto,
		lotList: KSK2020_R01LotDto[],
		detailList: KSK2020_R01DetailDto[],
		inspectList: KSK2020_R01InspectDto[],
	) => {

		let warningMessage = '(지시No 조회필요)';
		
		if (!validateString(header.productOrderNo)) {
			showWarning('지시No를 입력해주세요.'); return false;
		}
		if (!validateString(header.compCd)) {
			showWarning('지시정보가 없습니다. 사업장을 선택해주세요.' + warningMessage); return false;
		}
		if (!validateString(header.workplaceCd)) {
			showWarning('공정명을 선택해주세요.' + warningMessage); return false;
		}
		if (!validateString(header.itemCd)) {
			showWarning('품목코드를 입력해주세요.' + warningMessage); return false;
		}
		if (!itemCdMap.has(header.itemCd)) {
			showWarning('품목코드가 존재하지 않습니다.' + warningMessage); return false;
		}
		if (!validateString(header.logicCenter)) {
			showWarning('입고물류를 선택해주세요.' + warningMessage); return false;
		}
		if (!validateString(header.warehouseCd)) {
			showWarning('입고창고를 선택해주세요.' + warningMessage); return false;
		}
		if (!validateString(header.orderEmp)) {
			showWarning('담당자를 입력해주세요.' + warningMessage); return false;
		}
		if (!validateEmployeeCd(header.orderEmp, employeeCdList)) {
			showWarning('담당자가 존재하지 않습니다.(입력칸을 더블클릭하거나 엔터키로 세부사항을 열어서 지정해주세요)'); return false;
		}
		if (Number(header.productQty) + Number(header.badQty) > Number(header.orderQtyView)) {
			if (header.workStartDt == null || header.workEndDt == null) {
				showWarning('생산양품량과 불량수량의 합이 지시잔량을 초과하는 경우, 작업 시작시간과 종료시간을 등록해주세요.');
				return false;
			}
		}
		// if (header.productQty > header.orderQty) {
		// 	showWarning('양품수량(lot 작업지시량)은 생산실적수량보다 클 수 없습니다.'); return false;
		// }

		let activeLotList: KSK2020_R01LotDto[] = [];
 
		// Lot 항목 검증
		if (lotList.length > 0) {
			const deletedLotListToNumber = deletedKSK2020_R01LotList.map(value => Number(value));
			activeLotList = lotList.filter(detail => 
				!deletedLotListToNumber.includes(detail.valueIndex)
			);

			// 1. lotNo가 있는 항목들만 골라냅니다.
			const lotNos = activeLotList.map(detail => detail.lotNo).filter(lotNo => lotNo); // lotNo 가져오기
			const duplicates = lotNos.filter((lot, index) => lotNos.indexOf(lot) !== index);	// lotNo 중복 제거
			
			if (duplicates.length > 0) {
				showWarning("중복된 LOT No가 있습니다.\nLOT No: " + duplicates[0]);
				return false;
			}
		}

		const validateLotList = lotList.filter(detail => 
			detail.inserted === true && detail.lotQty > 0
		);
			
		//lot 입력행이나 자재출고 수정행이 없으면 반려
		if(validateLotList.length === 0) {
			showWarning('Lot 입력행을 입력해주세요. (최소 1개 이상 입력)'); return false;
		}


		//자재출고 검증
		if (detailList.length > 0) {
			for (const detail of detailList) {
				if (detail.transportQty > detail.lotQty) {
					showWarning(`${detail.childItemcd} 품목의 출고량은 재고량보다 클 수 없습니다.`); return false;
				}
			}

			//childItemcd 기준으로 각 요소들을 분배해서 각 품목코드에 대한 출고량을 계산, 소요량과 비교해서 출고량이 소요량보다 클 수 없다
			// 현재는 수정해서 출고량이 소요량보다 높아도 되는데 롤백할 가능성이 있어서 코드를 보관함
			//
			const childItemcdList = detailList.map(detail => detail.childItemcd).filter(childItemcd => childItemcd);
			const uniqueChildItemcdList = Array.from(new Set(childItemcdList));
			for (const childItemcd of uniqueChildItemcdList) {
				const childItemcdDetailList = detailList.filter(detail => detail.childItemcd === childItemcd);
				const childItemcdTransportQty = childItemcdDetailList.reduce((sum, detail) => sum + detail.transportQty, 0);
				// if (childItemcdTransportQty > childItemcdDetailList[0].bomUsingQty) {
				// 	showWarning(`${childItemcd} 품목의 출고량은 소요량보다 클수 없습니다. `); return false;
				// }
			}
		}
		//불량사유 검증
		if (inspectList.length > 0) {
			const deletedInspectListToNumber = deletedKSK2020_R01InspectList.map(value => Number(value));
			const activeInspectList = inspectList.filter(inspect => 
				!deletedInspectListToNumber.includes(inspect.valueIndex)
			);

			// 1. badCase가 있는 항목들만 골라냅니다.
			const badCases = activeInspectList.map(detail => detail.badCase).filter(badCase => badCase);	// badCase 가져오기
			const duplicates = badCases.filter((badCase, index) => badCases.indexOf(badCase) !== index);	// badCase 중복 제거

			//불량사유 코드명 추출
			const badCaseNames = duplicates.map(badCase => faultyValueList.find(value => value.minorCd === badCase)?.codeNm);
			
			if (duplicates.length > 0) {
				showWarning("중복된 불량사유가 있습니다.\n불량사유: " + badCaseNames.join(', '));
				return false;
			}
		}
		
		return true;
	}
	
	const assignLotNoToLists = useCallback(async (currentLotList: KSK2020_R01LotDto[]) => {
		const deletedKSK2020_R01LotList_Number = deletedKSK2020_R01LotList.map(value => Number(value));

		const activeList = currentLotList.filter(lot => !deletedKSK2020_R01LotList_Number.includes(lot.valueIndex));
		const newLotList = await Promise.all(activeList.map(async (lot) => {
			let generatedLotNo = lot.lotNo;

			// API 호출하여 LotNo 생성
			const res = await createKSK2020_R01LotNo();
			if (res.data && res.data.successFlag) {
				generatedLotNo = res.data.data;
			}

			// 업데이트된 LotNo를 가진 새 객체 반환
			return {
				...lot,
				lotNo: generatedLotNo
			};
		}));
		
		// 3. 상태 업데이트
		if (newLotList.length > 0) {
			setKSK2020_R01LotList(newLotList);
		}

		return newLotList;
	}, [setKSK2020_R01LotList, deletedKSK2020_R01LotList]);
	
	const handleSaveClick = useCallback(async () => {
		setLoadingSpinner(true);
		let valid = true;
		if(!validateInsertData(editKSK2020_R01!, KSK2020_R01LotList, KSK2020_R01DetailList, KSK2020_R01InspectList)) valid = false;
		if(!valid) { setLoadingSpinner(false); return; }
		
		// STEP 0: 초기화 전에 LOT 번호 가져와서 WMS1020_R01LotMap의 각 row에 추가
		// ========================================
		const newLotList = await assignLotNoToLists(KSK2020_R01LotList);
		
		let processName = '';
		let newHeaderList: KSK2020_R01HeaderDto[] = [];
		let newInspectList: KSK2020_R01InspectDto[] = [];
		let newDetailList: KSK2020_R01DetailDto[] = [];
		let responseData: KSK2020_R01Dto = {
			productOrderHeaderDto: editKSK2020_R01!,
			productResultHeaderDto: getProductResultHeaderDto(editKSK2020_R01!),
			wmsStockLotDtoList: newLotList,
			bomDtoList: KSK2020_R01DetailList,
			prdInspectResultDtoList: KSK2020_R01InspectList,
		};
		let deleteHeaderFlag = false;

		try {
			
		
			if (editKSK2020_R01) {

				if (newLotList.length === 0) {
					processName = 'delete';
					const deleteResponse = await deleteKSK2020_R01(editKSK2020_R01.productOrderNo);

					newHeaderList = KSK2020_R01List.filter(value => value.productOrderNo !== editKSK2020_R01.productOrderNo);

					if (deleteResponse && deleteResponse.data) {
						if (deleteResponse.data.successFlag) {
							showSuccess('생산실적 삭제가 성공하였습니다.');
							setMessage('생산실적 삭제가 성공하였습니다.');
						}else return;
					}
				} else {
					processName = 'patch';

					const deletedKSK2020_R01InspectList_Number = deletedKSK2020_R01InspectList.map(value => Number(value));
					const patchResponse = await patchKSK2020_R01({
						productOrderHeaderDto: editKSK2020_R01!,
						productResultHeaderDto: getProductResultHeaderDto(editKSK2020_R01!),
						wmsStockLotDtoList: newLotList.filter(value => (
							(value.lotQty > 0 && value.inserted === true)
						)),
						bomDtoList: KSK2020_R01DetailList,
						prdInspectResultDtoList: KSK2020_R01InspectList.filter(value => (
								!deletedKSK2020_R01InspectList_Number.includes(value.valueIndex) 
								&& validateString(value.badCase)
							)
						),
					});

					responseData = patchResponse.data.data;
					

					const responseproductOrderHeaderDto = {
						...responseData.productOrderHeaderDto,
						resultQty: responseData.productOrderHeaderDto.resultQty,
						orderQty: responseData.productOrderHeaderDto.orderQty,
						orderQtyView: responseData.productOrderHeaderDto.orderQty - responseData.productOrderHeaderDto.resultQty,
					};

					newHeaderList = KSK2020_R01List.map(value => {
						if (value.productOrderNo === responseData.productOrderHeaderDto.productOrderNo) {
							return responseproductOrderHeaderDto;
						}
						return value;
					});
					//생산양품량이 작업지시잔량이랑 같거나 크면, 해당 header을 list에서 삭제
					if (editKSK2020_R01!.productQty >= editKSK2020_R01!.orderQtyView) {
						newHeaderList = KSK2020_R01List.filter(value => value.productOrderNo !== responseData.productOrderHeaderDto.productOrderNo);	
						deleteHeaderFlag = true;
					}
					
					if (patchResponse?.data?.data && patchResponse.data.successFlag) {

						showSuccess('생산실적이 수정되었습니다.');
						setMessage('생산실적이 수정되었습니다.');
					}else {
						// 서버 응답이 예상과 다를 경우의 에러 처리
						showWarning('생산실적 수정 후 서버로부터 올바른 데이터를 받지 못했습니다.');
						return;
					}
				}
			} else {
				processName = 'post';
				const postResponse = await postKSK2020_R01({
					productOrderHeaderDto: editKSK2020_R01!,
					productResultHeaderDto: getProductResultHeaderDto(editKSK2020_R01!),
					wmsStockLotDtoList: newLotList,
					bomDtoList: KSK2020_R01DetailList,
					prdInspectResultDtoList: KSK2020_R01InspectList.filter(value => (
						validateString(value.badCase)
					)),
				});
				responseData = postResponse.data.data;

				const responseproductOrderHeaderDto = {
					...responseData.productOrderHeaderDto,
					resultQty: responseData.productResultHeaderDto.productQty
				};

				newHeaderList = [
					...KSK2020_R01List,
					responseproductOrderHeaderDto,
				] as KSK2020_R01HeaderDto[];
				
				if (postResponse?.data?.data && postResponse.data.successFlag) {
					showSuccess('생산실적이 등록되었습니다.');
					setMessage('생산실적이 등록되었습니다.');
				}else {
					// 서버 응답이 예상과 다를 경우의 에러 처리
					showWarning('생산실적 등록 후 서버로부터 올바른 데이터를 받지 못했습니다.');
					setLoadingSpinner(false);
					return;
				}
			}
		} catch (error) {
			console.error("생산실적 작업 중 오류가 발생했습니다.:", error);
			// showError('생산실적 작업 중 오류가 발생했습니다.');
			setLoadingSpinner(false);
			return;
		}


		if (processName === 'delete' || deleteHeaderFlag) {
			setKSK2020_R01List(newHeaderList);

			// setSelectedKSK2020_R01(undefined);
			setEditKSK2020_R01({ ...defaultKSK2020_R01HeaderDto, })
			setKSK2020_R01DetailList([]);
			setKSK2020_R01LotList([]);

			setSelectedKSK2020_R01DetailList([]);
			setSelectedKSK2020_R01LotList([]);

			setOriginalKSK2020_R01DetailList([]);
			setOriginalKSK2020_R01LotList([]);

			setDeletedKSK2020_R01DetailList([]);
			setDeletedKSK2020_R01LotList([]);

			deleteHeaderFlag = false;

			handleCreateClick();
		}else if (processName === 'patch' || processName === 'post') {
			setKSK2020_R01List(newHeaderList);
			if (processName === 'post') {
				initKSK2020_R01LotData();
			} else {
				setKSK2020_R01LotList([]);
				insertKSK2020_R01LotList([defaultKSK2020_R01LotRow()]);
			}

			//응답 성공했을때의 데이터의 productOrderHeaderDto는 빈곳이 많으므로, 보간해야함
			const newEditKSK2020_R01 = {
				...responseData.productOrderHeaderDto,
				orderQty: responseData.productOrderHeaderDto.orderQty,
				orderQtyView: responseData.productOrderHeaderDto.orderQty - responseData.productOrderHeaderDto.resultQty,
				itemStatus: responseData.productResultHeaderDto.itemStatus || itemStatusList[0]?.minorCd || '',
			productDt: responseData.productResultHeaderDto.productDt || formatDate(new Date()),
				logicCenter: responseData.productResultHeaderDto.logicCenter || '',
				warehouseCd: responseData.productResultHeaderDto.warehouseCd || '',
				outWarehouseCd: responseData.productResultHeaderDto.outWarehouseCd || '',
				badWarehouseCd: responseData.productResultHeaderDto.badWarehouseCd || '',
				productQty: 0,
				badQty: 0,
			};

			setEditKSK2020_R01({
				...newEditKSK2020_R01,
				workStartDt: editKSK2020_R01?.workStartDt,
				workEndDt: editKSK2020_R01?.workEndDt,
				productResultNo: responseData.productResultHeaderDto.productResultNo || editKSK2020_R01?.productResultNo || '',
			});
			if (processName === 'patch') {
				setOriginalKSK2020_R01LotList(responseData.wmsStockLotDtoList);
			}
			
			//기존 bomDetailList에서 responseData.bomDtoList에 존재하는 lotno, itemno인 행만 가져옴
			//  responseData.bomDtoList를 적용
			const newDetailList = KSK2020_R01DetailList.filter(
				value => responseData.bomDtoList.some(response => 
					response.childItemcd === value.childItemcd
					&& response.itemNo === value.itemNo
					&& response.lotNo === value.lotNo
				)
			).map(value => ({ 
				...value, 
				...responseData.bomDtoList.find(response => 
					response.childItemcd === value.childItemcd
					&& response.itemNo === value.itemNo
					&& response.lotNo === value.lotNo
				),
				childItemUsage: value.childItemUsage, 
				bomUsingQty: 0, 
				transportQty: 0, 
				isModified: false,
			}));
			setKSK2020_R01DetailList(newDetailList);
			setOriginalKSK2020_R01DetailList(newDetailList);
		}

		// setSelectedKSK2020_R01(undefined);
		setDeletedKSK2020_R01LotList([]);
		setSelectedKSK2020_R01LotList([]); // 저장 후 상세행 선택 상태 초기화
		setSelectedKSK2020_R01DetailList([]);
		
		setKSK2020_R01InspectList([defaultKSK2020_R01InspectRow()]);
		setSelectedKSK2020_R01InspectList([]);
		setDeletedKSK2020_R01InspectList([]);
		setOriginalKSK2020_R01InspectList([]);

		setTimeout(() => {
			setMessage('');
		}, 5000)
		setLoadingSpinner(false);
	
	}, [
		editKSK2020_R01,
		// selectedKSK2020_R01, 
		KSK2020_R01LotList,
		KSK2020_R01DetailList,
		KSK2020_R01InspectList, deletedKSK2020_R01InspectList,
		KSK2020_R01List, setKSK2020_R01List
	]);

	const getServerMessage = useCallback((error: unknown) => {
		const serverMessage = (error as AxiosError<{ message: string }>)?.response?.data?.message;
		return serverMessage || '작업종료등록 중 오류가 발생했습니다.';
	}, []);	

	const handleWorkTimeClick = useCallback(async (productOrderNo: string, processType: KSK2020_R01WorkTimeProcessType, manualTime?: Date, rawTime?: { month: string, day: string, hour: string, minute: string }) => {
		const latestEdit = useKSK2020_R01Store.getState().editKSK2020_R01 ?? editKSK2020_R01;
		const isReset = processType === 'workStartReset' || processType === 'workEndReset';
		const isStart = processType === 'workStart' || processType === 'workStartReset';
		const modalType = isStart ? 'start' : 'end';

		// 작업지시번호가 없으면 모달만 열고 시·분은 브라우저 현재시간으로 채움
		if (!validateString(productOrderNo)) {
			if (isReset || manualTime || rawTime) {
				showWarning('작업지시 번호를 입력하세요.');
				return false;
			}
			setWorkTimeModalType(modalType);
			setWorkTimeModalVisible(true);
			return false;
		}

		if (!isReset && rawTime) {
			const m = Number(rawTime.month);
			const d = Number(rawTime.day);
			const h = Number(rawTime.hour);
			const min = Number(rawTime.minute);

			if (isNaN(m) || m < 1 || m > 12) { showWarning('월은 1~12월 사이로 입력해주세요.'); return false; }
			if (isNaN(d) || d < 1 || d > 31) { showWarning('일은 1~31일 사이로 입력해주세요.'); return false; }
			if (isNaN(h) || h < 0 || h > 23) { showWarning('시는 0~23 사이로 입력해주세요.'); return false; }
			if (isNaN(min) || min < 0 || min > 59) { showWarning('분은 0~59분 사이로 입력해주세요.'); return false; }
		}

		const timeField: 'workStartDt' | 'workEndDt' = isStart ? 'workStartDt' : 'workEndDt';
		const successMsg = isReset
			? (isStart ? '작업시작 초기화에 성공하였습니다.' : '작업종료 초기화에 성공하였습니다.')
			: (isStart ? '작업시작에 성공하였습니다.' : '작업종료에 성공하였습니다.');
		const failMsg = isReset
			? (isStart ? '작업시작 초기화에 실패하였습니다.' : '작업종료 초기화에 실패하였습니다.')
			: (isStart ? '작업시작에 실패하였습니다.' : '작업종료에 실패하였습니다.');

		let targetTime: Date;
		if (isReset) {
			// 초기화는 UTC 기준 Date로 생성해 JSON 직렬화 시 1900-01-01T00:00:00.000Z로 전송합니다.
			targetTime = new Date(defaultValidateDateString);
		} else if (manualTime) {
			targetTime = manualTime;
		} else {
			// 시간이 없으면 현재 로컬 시간을 사용
			targetTime = new Date();
			// targetTime.setHours(targetTime.getHours() + 9);
			const isNewProductResultSession = isStart && !validateString(latestEdit?.productResultNo ?? '');
			// 작업종료는 항상 모달에서 시간 입력 후 전송 / 작업시작은 신규실적·기존시각 수정 시 모달
			const needsWorkTimeModal = !isStart
				|| isNewProductResultSession
				|| !isUnsetWorkDateTime(latestEdit?.[timeField]);
			if (needsWorkTimeModal) {
				setWorkTimeModalType(modalType);
				setWorkTimeModalVisible(true);
				return false;
			}
		}

		// 작업시작 < 작업종료 제약 (둘 중 하나라도 초기값이면 건너뜀)
		// 모달 입력 또는 현재 로컬 시각을 기준으로 비교
		if (!isReset) {
			// const toWallClockForCompare = (time: Date): Date => {
			// 	const wall = new Date(time);
			// 	wall.setHours(wall.getHours() - 9);
			// 	return wall;
			// };

			let compareStartDt: Date | string | undefined;
			let compareEndDt: Date | string | undefined;

			if (rawTime) {
				const year = new Date().getFullYear();
				const wallClock = new Date(
					year,
					Number(rawTime.month) - 1,
					Number(rawTime.day),
					Number(rawTime.hour),
					Number(rawTime.minute),
				);
				if (isStart) {
					compareStartDt = wallClock;
					compareEndDt = latestEdit?.workEndDt;
				} else {
					compareStartDt = latestEdit?.workStartDt;
					compareEndDt = wallClock;
				}
			} else {
				const wallTarget = new Date(targetTime);
				compareStartDt = isStart ? wallTarget : latestEdit?.workStartDt;
				compareEndDt = isStart ? latestEdit?.workEndDt : wallTarget;
			}

			const isStartInitial = isUnsetWorkDateTime(compareStartDt);
			const isEndInitial = isUnsetWorkDateTime(compareEndDt);

			if (!isStartInitial && !isEndInitial) {
				const startMs = new Date(compareStartDt!).getTime();
				const endMs = new Date(compareEndDt!).getTime();
				if (startMs >= endMs) {
					showWarning('작업시작시간은 작업종료시간보다 빨라야 합니다.');
					return false;
				}
			}
		}

		try {
			if (!latestEdit) {
				showWarning('작업지시 정보가 없습니다.');
				return false;
			}
			if (!isStart && !isReset && !validateString(latestEdit.productResultNo)) {
				showWarning('생산실적코드를 입력하세요.');
				return false;
			}

			// 최초 작업시작(생산실적코드 없음)과 기존 실적의 시간 수정을 구분
			const hadProductResultNoBefore = validateString(latestEdit.productResultNo);
			const resolvedProductDt = resolveKSK2020_R01ProductDt(latestEdit);

			const headerWithWorkTime: KSK2020_R01HeaderDto = isStart
				? {
					...latestEdit,
					productDt: resolvedProductDt,
					// 최초 실적 생성 시 백엔드가 orderDt로 productDt를 설정함
					...(!hadProductResultNoBefore ? { orderDt: resolvedProductDt } : {}),
					workStartDt: toLocalDateTime(targetTime),
				}
				: {
					...latestEdit,
					workEndDt: toLocalDateTime(targetTime),
				};

			const postResponse = await postKSK2020_R01({
				productOrderHeaderDto: headerWithWorkTime,
				productResultHeaderDto: getProductResultHeaderDto(headerWithWorkTime),
				wmsStockLotDtoList: KSK2020_R01LotList,
				bomDtoList: KSK2020_R01DetailList,
				prdInspectResultDtoList: KSK2020_R01InspectList.filter(value => (
					validateString(value.badCase)
				)),
			});
			const responseData = postResponse.data;

			if(responseData && responseData.successFlag) {
				showSuccess(successMsg);
				setMessage(successMsg);

				const dto = responseData.data as KSK2020_R01Dto;
				const orderHeader = dto?.productOrderHeaderDto;
				const resultHeader = dto?.productResultHeaderDto;

				if (!isStart) {
					await resetToWorkOrderInitialState();
					return true;
				}

				const nextFrom = orderHeader?.workStartDt ?? resultHeader?.workStartDt ?? toLocalDateTime(targetTime);
				const resultProductResultNo = resultHeader?.productResultNo ?? '';
				const orderProductResultNo = orderHeader?.productResultNo ?? '';
				const nextProductResultNo = validateString(resultProductResultNo)
					? resultProductResultNo
					: validateString(orderProductResultNo)
					? orderProductResultNo
					: latestEdit.productResultNo;
				if (validateString(nextProductResultNo)) {
					setNotProductResult(false);
				}
				const nextProductDt = resolveKSK2020_R01ProductDt(
					resultHeader ?? latestEdit,
					resolvedProductDt,
				);
				// 최초 작업시작 시 LOT 목록만 초기화하고 조회한 생산량은 유지
				if (!hadProductResultNoBefore) {
					initKSK2020_R01LotData(false);
				}
				const editAfterInit = useKSK2020_R01Store.getState().editKSK2020_R01;
				if (editAfterInit) {
					const resetWorkEndDt = defaultValidateDateString.replace(' ', 'T');
					setEditKSK2020_R01({
						...editAfterInit,
						workStartDt: nextFrom,
						workEndDt: !hadProductResultNoBefore
							? resetWorkEndDt
							: (orderHeader?.workEndDt ?? resultHeader?.workEndDt ?? editAfterInit.workEndDt),
						productResultNo: nextProductResultNo,
						productDt: nextProductDt,
						// ResultInfo 작업자 — productResultHeaderDto 기준 반영
						productEmp: resultHeader?.productEmp || editAfterInit.productEmp || editAfterInit.orderEmp || '',
						productEmpNm: resultHeader?.productEmpNm || editAfterInit.productEmpNm || editAfterInit.orderEmpNm || '',
						jobTeam: resultHeader?.jobTeam || editAfterInit.jobTeam || '',
					});
				}
				return true;
			}else {
				showWarning(failMsg);
				return false;
			}
		} catch (error) {
			console.error(`${isStart ? '작업시작' : '작업종료'}등록 중 오류가 발생했습니다.:`, error);
			showError(getServerMessage(error));
			return false;
		}
	}, [editKSK2020_R01, KSK2020_R01LotList, KSK2020_R01DetailList, KSK2020_R01InspectList, initKSK2020_R01LotData, resetToWorkOrderInitialState, setNotProductResult]);

	//헤더의 정보를 받아서 기본값이 null이 아닌 빈 문자열 값을 찾아서 시스템코드의 기본값으로 표시되게 하기
	const handleProductResultInfoCode = useCallback((headerData: KSK2020_R01HeaderDto): Partial<KSK2020_R01HeaderDto> => {
		const defaults: Partial<KSK2020_R01HeaderDto> = {};

		defaults.productDt = resolveKSK2020_R01ProductDt(headerData);
				
		if(!validateString(headerData.compCd) && compCdList.length > 0)				defaults.compCd = compCdList[0].compCd;
		if(!validateString(headerData.workplaceCd) && workPlaceList.length > 0)		defaults.workplaceCd = workPlaceList[0].workplaceCd;

		if(!validateString(headerData.logicCenter) && wmsCdList.length > 0)			{
			defaults.logicCenter = wmsCdList[0].minorCd;
		}		
		defaults.logicCenter = headerData.logicCenter ? headerData.logicCenter : defaults.logicCenter;


		let warehouseListToUse = warehouseCdList.filter(value => (value.logicCenter === defaults.logicCenter
			&& (value.materialYn === 'Y' || value.goodsYn === 'Y' || value.productYn === 'Y' )
		));
		if(!validateString(headerData.warehouseCd) && warehouseListToUse.length > 0)	{
			defaults.warehouseCd = warehouseListToUse[0].warehouseCd;
		}

		defaults.itemStatus = validateString(headerData.itemStatus) ? headerData.itemStatus : (itemStatusList[0]?.minorCd ?? '');

		defaults.orderEmp = headerData.orderEmp ? headerData.orderEmp : (employeeCdList[0]?.empNo ?? '');
		defaults.orderEmpNm = headerData.orderEmpNm ? headerData.orderEmpNm : (employeeCdList[0]?.empNm ?? '');

		defaults.badQty = headerData.badQty ? headerData.badQty : 0;
	
		return defaults;
	}, [compCdList, workPlaceList, employeeCdList, wmsCdList, warehouseCdList, itemStatusList])

	const handleFetchBomProductList = useCallback(async ( productOrderNo: string, itemCd: string, outWarehouseCd: string, logicCenter: string ) => {
		const responseData = (await getKSK2020_R01DetailStockList(productOrderNo, itemCd, outWarehouseCd, logicCenter)).data.data;
		if(responseData && responseData.length > 0){

			//KSK2020_R01DetailList와 responseData를 비교해서
			//lotNo, childItemcd(itemCd)가 같으면 warehouseCd, logicCenter, lotQty를 업데이트
			const currentDetailList = useKSK2020_R01Store.getState().KSK2020_R01DetailList;
			const updatedDetails = currentDetailList.map((value) => {
				const response = responseData.find(response => 
					response.lotNo === value.lotNo && response.childItemcd === value.childItemcd
				);
				return {
					...value,
					logicCenter: value.logicCenter === logicCenter ? logicCenter : wmsCdList[0].minorCd,
					lotQty: response ? response.lotQty : 0,
				}
			});

			setKSK2020_R01DetailList(updatedDetails);
		}
		setOriginalKSK2020_R01DetailList(responseData);
		detailGridRef.current?.api.ensureIndexVisible(0, 'top');
		setMessage(`상세내역 ${responseData.length}건을 조회하였습니다.`);
		setTimeout(() => setMessage(""), 5000);


	}, [editKSK2020_R01?.productOrderNo, editKSK2020_R01?.itemCd, editKSK2020_R01?.warehouseCd, editKSK2020_R01?.logicCenter])


	
	// input form 팝업 열기 이벤트 핸들러
	const { getFieldHandlers: getProductWorkFieldHandlers } = useInfoFormEvents({
		editData: editKSK2020_R01,
		setEditData: setEditKSK2020_R01,
		defaultData: { ...defaultKSK2020_R01HeaderDto, inserted: true },
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'KSK2020_R01'
	});

	//생산실적코드 기준 생산결과 조회
	const fetchProductResult = useCallback(async (headerData: KSK2020_R01HeaderDto) => {
		let apiHeaderData: KSK2020_R01ProductResultDto | null = null;
		try {
			const transportResponse = await getKSK2020_R01ProductResultList(headerData.productResultNo!);
			apiHeaderData = transportResponse.data.data;

			let baseDataForDefaults;
			if (apiHeaderData && apiHeaderData.productResultNo) {
				setNotProductResult(false);
				const preservedProductQty = headerData.productQty ?? 0;
				baseDataForDefaults = {
					...defaultKSK2020_R01HeaderDto,
					...headerData,
					...apiHeaderData,
					orderQty: headerData.orderQty,
					orderQtyView: headerData.orderQtyView,
					productQty: preservedProductQty,
					badQty: 0,
					itemStatus: apiHeaderData.itemStatus ? apiHeaderData.itemStatus : (itemStatusList[0]?.minorCd ?? ''),
				};
			} else {
				setNotProductResult(true);
				baseDataForDefaults = {
					...defaultKSK2020_R01HeaderDto,
					...headerData,
				};
			}

			const defaultValues = handleProductResultInfoCode(baseDataForDefaults);

			setEditKSK2020_R01({
				...baseDataForDefaults,
				...defaultValues,
			});
		} catch (error) {
			console.error("ProductResult 내역 조회 실패:", error);
			setNotProductResult(true);
		}

		if (apiHeaderData && apiHeaderData.productResultNo) {
			return apiHeaderData;
		}
		return null;
	}, [handleProductResultInfoCode, setEditKSK2020_R01, setNotProductResult, itemStatusList]);

	const fetchStockLotList = useCallback(async (productResultNo: string) => {
		try {
			const response = await getKSK2020_R01StockLot(productResultNo);
			const lotList = response.data.data ?? [];

			setDeletedKSK2020_R01LotList([]);
			setSelectedKSK2020_R01LotList([]);

			if (lotList.length > 0) {
				setKSK2020_R01LotList([]);
				insertKSK2020_R01LotList(lotList);
				setOriginalKSK2020_R01LotList(lotList);
			} else {
				initKSK2020_R01LotData();
			}
		} catch (error) {
			console.error('LOT 조회 실패:', error);
			initKSK2020_R01LotData();
		}
	}, [
		initKSK2020_R01LotData,
		insertKSK2020_R01LotList,
		setDeletedKSK2020_R01LotList,
		setKSK2020_R01LotList,
		setOriginalKSK2020_R01LotList,
		setSelectedKSK2020_R01LotList,
	]);

	const handleLotCountChange = useCallback(async (name: string, newValue: number) => {
		if (name !== 'plcCount') {
			return;
		}
		if (isLotCountResettingRef.current) {
			showWarning('실적 Count 초기화 처리 중입니다.');
			return;
		}

		const currentEdit = useKSK2020_R01Store.getState().editKSK2020_R01;
		if (!currentEdit || !validateString(currentEdit.workplaceCd)) {
			showWarning('작업장 정보가 없습니다.');
			return;
		}

		const currentPlcCount = Number(currentEdit.plcCount ?? 0);
		const adjustmentQty = newValue - currentPlcCount;
		if (adjustmentQty !== 1 && adjustmentQty !== -1) {
			showWarning('실적 Count는 +1 또는 -1씩 조정할 수 있습니다.');
			return;
		}

		const workplaceCd = currentEdit.workplaceCd;
		lotCountAdjustmentVersionRef.current += 1;
		lotCountAdjustmentPendingRef.current += 1;
		setEditKSK2020_R01({
			...currentEdit,
			plcCount: newValue,
		});

		try {
			await patchKSK2020_R01LotCount(workplaceCd, adjustmentQty);
		} catch (error) {
			if (lotCountAdjustmentErrorRef.current == null) {
				lotCountAdjustmentErrorRef.current =
					(error as AxiosError<{ message: string }>)?.response?.data?.message
					|| '실적 Count 조정 중 오류가 발생했습니다.';
			}
		} finally {
			lotCountAdjustmentPendingRef.current -= 1;
			if (lotCountAdjustmentPendingRef.current !== 0) {
				return;
			}

			const syncVersion = lotCountAdjustmentVersionRef.current;
			try {
				const lotCountResponse = await getKSK2020_R01LotCountOne(workplaceCd);
				if (lotCountAdjustmentPendingRef.current !== 0
					|| lotCountAdjustmentVersionRef.current !== syncVersion) {
					return;
				}

				const latestEdit = useKSK2020_R01Store.getState().editKSK2020_R01;
				if (latestEdit?.workplaceCd === workplaceCd) {
					const pendingLotQty = Number(lotCountResponse.data.data?.pendingLotQty) || 0;
					setEditKSK2020_R01({
						...latestEdit,
						plcCount: pendingLotQty,
					});
				}
			} catch (error) {
				if (lotCountAdjustmentErrorRef.current == null) {
					lotCountAdjustmentErrorRef.current =
						(error as AxiosError<{ message: string }>)?.response?.data?.message
						|| '실적 Count 조정값 재조회에 실패했습니다.';
				}
			} finally {
				if (lotCountAdjustmentPendingRef.current === 0
					&& lotCountAdjustmentVersionRef.current === syncVersion
					&& lotCountAdjustmentErrorRef.current != null) {
					showWarning(lotCountAdjustmentErrorRef.current);
					lotCountAdjustmentErrorRef.current = null;
				}
			}
		}
	}, [setEditKSK2020_R01]);

	const handleLotCountResetClick = useCallback(async () => {
		if (isLotCountResettingRef.current) return;
		if (lotCountAdjustmentPendingRef.current !== 0) {
			showWarning('실적 Count 조정 처리 후 다시 시도해주세요.');
			return;
		}

		const currentEdit = useKSK2020_R01Store.getState().editKSK2020_R01;
		if (!currentEdit || !validateString(currentEdit.workplaceCd)) {
			showWarning('작업장 정보가 없습니다.');
			return;
		}

		const workplaceCd = currentEdit.workplaceCd;
		const resetVersion = lotCountAdjustmentVersionRef.current + 1;
		lotCountAdjustmentVersionRef.current = resetVersion;
		lotCountAdjustmentPendingRef.current += 1;
		isLotCountResettingRef.current = true;
		setIsLotCountResetting(true);
		try {
			const response = await patchKSK2020_R01LotCountReset(workplaceCd);
			if (lotCountAdjustmentVersionRef.current !== resetVersion) return;
			const latestEdit = useKSK2020_R01Store.getState().editKSK2020_R01;
			if (!latestEdit || latestEdit.workplaceCd !== workplaceCd) return;
			const pendingLotQty = Number(response.data.data?.pendingLotQty) || 0;
			setEditKSK2020_R01({ ...latestEdit, plcCount: pendingLotQty, pendingLotQty: 0 });
		} catch (error) {
			const serverMessage = (error as AxiosError<{ message: string }>)?.response?.data?.message;
			showWarning(serverMessage || '실적 Count 초기화 중 오류가 발생했습니다.');
		} finally {
			lotCountAdjustmentPendingRef.current = Math.max(0, lotCountAdjustmentPendingRef.current - 1);
			isLotCountResettingRef.current = false;
			setIsLotCountResetting(false);
		}
	}, [setEditKSK2020_R01]);

	const handleLotCreateClick = useCallback(async () => {
		if (!editKSK2020_R01) {
			showWarning('작업지시 정보가 없습니다.');
			return;
		}
		if (!validateString(editKSK2020_R01.productOrderNo)) {
			showWarning('작업지시 번호를 입력하세요.');
			return;
		}
		if (!validateString(editKSK2020_R01.productResultNo)) {
			showWarning('생산실적코드를 입력하세요.');
			return;
		}
		const pendingLotQty = editKSK2020_R01.pendingLotQty ?? 0;
		if (pendingLotQty <= 0) {
			showWarning('생산량을 입력해주세요.');
			return;
		}
		for (const detail of KSK2020_R01DetailList) {
			if (detail.transportQty > detail.lotQty) {
				showWarning(`${detail.childItemcd} 품목의 출고량은 재고량보다 클 수 없습니다.`);
				return;
			}
		}

		setLoadingSpinner(true);
		try {
			const lotNoRes = await createKSK2020_R01LotNo();
			const lotNo = lotNoRes.data?.successFlag ? lotNoRes.data.data : '';
			if (!lotNo) {
				showWarning('LOT 번호 발행에 실패하였습니다.');
				return;
			}

			const newLot: KSK2020_R01LotDto = {
				...defaultKSK2020_R01LotRow(),
				lotNo,
				lotQty: pendingLotQty,
				inserted: true,
			};

			const deletedKSK2020_R01InspectList_Number = deletedKSK2020_R01InspectList.map(value => Number(value));
			const stockLotResponse = await postKSK2020_R01StockLot({
				productOrderHeaderDto: editKSK2020_R01,
				productResultHeaderDto: {
					...getProductResultHeaderDto(editKSK2020_R01),
					badQty: editKSK2020_R01.badQty ?? 0,
				},
				wmsStockLotDtoList: [newLot],
				bomDtoList: KSK2020_R01DetailList,
				prdInspectResultDtoList: KSK2020_R01InspectList.filter(value => (
					!deletedKSK2020_R01InspectList_Number.includes(value.valueIndex)
					&& validateString(value.badCase)
				)),
			});

			if (!stockLotResponse.data?.successFlag || !stockLotResponse.data.data) {
				showWarning('LOT 발행 후 서버로부터 올바른 데이터를 받지 못했습니다.');
				return;
			}

			const responseData = stockLotResponse.data.data;
			const qtyUpdate = resolveQtyAfterLotIssue(
				editKSK2020_R01,
				responseData.productOrderHeaderDto,
				pendingLotQty,
			);
			const responseProductOrderHeaderDto = {
				...responseData.productOrderHeaderDto,
				...qtyUpdate,
			};
			let remainingLotQty = 0;
			const workplaceCd = responseData.productOrderHeaderDto.workplaceCd || editKSK2020_R01.workplaceCd;
			if (validateString(workplaceCd)) {
				try {
					const lotCountResponse = await getKSK2020_R01LotCountOne(workplaceCd);
					remainingLotQty = Number(lotCountResponse.data.data?.pendingLotQty) || 0;
				} catch (error) {
					console.error('LOT 발행 후 잔여 생산수량 조회 실패:', error);
				}
			}

			setKSK2020_R01List(KSK2020_R01List.map(value => (
				value.productOrderNo === responseData.productOrderHeaderDto.productOrderNo
					? responseProductOrderHeaderDto
					: value
			)));

			setEditKSK2020_R01({
				...editKSK2020_R01,
				...responseData.productOrderHeaderDto,
				...qtyUpdate,
				itemStatus: responseData.productResultHeaderDto?.itemStatus || editKSK2020_R01.itemStatus || itemStatusList[0]?.minorCd || '',
				productResultNo: responseData.productResultHeaderDto?.productResultNo || editKSK2020_R01.productResultNo,
				plcCount: remainingLotQty,
				pendingLotQty: 0,
				badQty: responseData.productResultHeaderDto?.badQty ?? editKSK2020_R01.badQty ?? 0,
				workStartDt: editKSK2020_R01.workStartDt,
				workEndDt: editKSK2020_R01.workEndDt,
			});

			await handleFetchProductResultRef.current?.();

			// 발행 후 잔여 생산량에 맞춰 출고량·소요량 자동계산만 재적용 (출고창고 등 기존 행 정보는 유지)
			const latestState = useKSK2020_R01Store.getState();
			setKSK2020_R01DetailList(
				recalculateDetailListWithTransport(
					latestState.KSK2020_R01DetailList,
					latestState.editKSK2020_R01,
				),
			);

			if (KSK2020_R01Filter.labelPrintAuto === 'Y') {
				try {
					const issuedLabelData = KSK2020_R01_buildLabelData(
						lotNo,
						latestState.editKSK2020_R01?.itemCd || editKSK2020_R01.itemCd,
						latestState,
					);
					await printBulkLabel([issuedLabelData], 'label1');
					showSuccess('LOT 발행 및 라벨 출력이 완료되었습니다.');
					setMessage('LOT 발행 및 라벨 출력이 완료되었습니다.');
				} catch (error) {
					console.error('LOT 발행 후 라벨 출력 실패:', error);
					const errorMessage = error instanceof Error ? error.message : '알 수 없는 오류';
					showWarning(`LOT 발행은 완료되었으나 라벨 출력에 실패했습니다: ${errorMessage}`);
					setMessage('LOT 발행이 완료되었습니다.');
				}
			} else {
				showSuccess('LOT 발행이 완료되었습니다.');
				setMessage('LOT 발행이 완료되었습니다.');
			}
		} catch (error) {
			console.error('LOT 발행 중 오류가 발생했습니다.:', error);
			const serverMessage = (error as AxiosError<{ message: string }>)?.response?.data?.message;
			showWarning(serverMessage || 'LOT 번호 발행 중 오류가 발생하였습니다.');
		} finally {
			setLoadingSpinner(false);
		}
	}, [
		KSK2020_R01DetailList,
		KSK2020_R01Filter.labelPrintAuto,
		KSK2020_R01InspectList,
		KSK2020_R01List,
		defaultKSK2020_R01LotRow,
		deletedKSK2020_R01InspectList,
		editKSK2020_R01,
		itemStatusList,
		printBulkLabel,
		setEditKSK2020_R01,
		setKSK2020_R01DetailList,
		setKSK2020_R01List,
		setLoadingSpinner,
		setMessage,
	]);

	const handleFetchProductResult = useCallback(async () => {
		if (isFetchingProductResultRef.current) return;
		isFetchingProductResultRef.current = true;

		try {
			const headerData = useKSK2020_R01Store.getState().editKSK2020_R01;
			if (!headerData || !validateString(headerData.productOrderNo)) {
				showWarning('작업지시 번호를 입력하세요.');
				getProductWorkFieldHandlers('productOrderNo')
					.onDoubleClick({ currentTarget: { blur: () => {}, value: '' } } as unknown as React.MouseEvent<HTMLInputElement>);
				return;
			}
			if (!validateString(headerData.productResultNo)) {
				showWarning('생산실적코드를 입력하세요.');
				getProductWorkFieldHandlers('productResultNo')
					.onDoubleClick({ currentTarget: { blur: () => {}, value: '' } } as unknown as React.MouseEvent<HTMLInputElement>);
				return;
			}

			const preservedProductQty = headerData.productQty ?? 0;

			setKSK2020_R01LotList([]);
			setKSK2020_R01DetailList([]);
			setKSK2020_R01InspectList([]);

			const productResult = await fetchProductResult(headerData);
			const currentHeader = useKSK2020_R01Store.getState().editKSK2020_R01 ?? headerData;

			if (productResult && productResult.productResultNo !== '') {
				await fetchDetailList(
					currentHeader.productOrderNo || headerData.productOrderNo || '',
					productResult.itemCd || '',
					productResult.productQty ?? 0,
					productResult.badQty ?? 0,
					currentHeader.outWarehouseCd,
					currentHeader.logicCenter,
					currentHeader.workplaceCd,
				);
				await handleFetchBomProductList(
					currentHeader.productOrderNo || headerData.productOrderNo || '',
					productResult.itemCd,
					currentHeader.outWarehouseCd,
					productResult.logicCenter || currentHeader.logicCenter || wmsCdList[0].minorCd,
				);
				await fetchStockLotList(productResult.productResultNo);
				await refreshInspectListFromServer(productResult.productResultNo);
			} else {
				await fetchDetailList(
					currentHeader.productOrderNo || headerData.productOrderNo || '',
					currentHeader.itemCd || '',
					0,
					0,
					currentHeader.outWarehouseCd,
					currentHeader.logicCenter,
					currentHeader.workplaceCd,
				);
				initKSK2020_R01LotData();
				setDeletedKSK2020_R01InspectList([]);
				setSelectedKSK2020_R01InspectList([]);
				setOriginalKSK2020_R01InspectList([]);
				setKSK2020_R01InspectList([]);
				insertKSK2020_R01InspectList([defaultKSK2020_R01InspectRow()]);
			}

			const latestEdit = useKSK2020_R01Store.getState().editKSK2020_R01;
			if (latestEdit) {
				setEditKSK2020_R01({ ...latestEdit, productQty: preservedProductQty });
			}
		} finally {
			isFetchingProductResultRef.current = false;
		}
	}, [
		fetchProductResult,
		fetchDetailList,
		fetchStockLotList,
		handleFetchBomProductList,
		getProductWorkFieldHandlers,
		initKSK2020_R01LotData,
		insertKSK2020_R01InspectList,
		defaultKSK2020_R01InspectRow,
		refreshInspectListFromServer,
		setDeletedKSK2020_R01InspectList,
		setEditKSK2020_R01,
		setKSK2020_R01LotList,
		setKSK2020_R01DetailList,
		setKSK2020_R01InspectList,
		setOriginalKSK2020_R01InspectList,
		setSelectedKSK2020_R01InspectList,
		wmsCdList,
	]);

	handleFetchProductResultRef.current = handleFetchProductResult;

	const handleFetchLotList = useCallback(async (): Promise<boolean> => {
		if(!validateString(editKSK2020_R01?.productOrderNo || '')) {
			getProductWorkFieldHandlers('productOrderNo')
				.onDoubleClick({ currentTarget: { blur: () => {}, value: '' } } as unknown as React.MouseEvent<HTMLInputElement>);
			return false;
		}

		setKSK2020_R01LotList([]);
		setKSK2020_R01DetailList([]);
		setKSK2020_R01InspectList([]);
		setDeletedKSK2020_R01LotList([]);
		setSelectedKSK2020_R01LotList([]);
		setOriginalKSK2020_R01LotList([]);
		setDeletedKSK2020_R01InspectList([]);
		setSelectedKSK2020_R01InspectList([]);
		setOriginalKSK2020_R01InspectList([]);

		const headerData = await fetchOne();
		if (!headerData) {
			return false;
		}

		await fetchDetailList(
			headerData.productOrderNo || '',
			headerData.itemCd || '',
			0,
			0,
			headerData.outWarehouseCd,
			headerData.logicCenter,
			headerData.workplaceCd,
		);

		initKSK2020_R01LotData(false);
		setKSK2020_R01InspectList([]);
		insertKSK2020_R01InspectList([defaultKSK2020_R01InspectRow()]);

		// fetchOne에서 생산실적코드·작업시간 등을 초기화하므로 이전 실적코드로 재조회하지 않음
		return true;
	}, [
		defaultKSK2020_R01InspectRow,
		editKSK2020_R01?.productOrderNo,
		fetchDetailList,
		fetchOne,
		getProductWorkFieldHandlers,
		initKSK2020_R01LotData,
		insertKSK2020_R01InspectList,
		setDeletedKSK2020_R01InspectList,
		setDeletedKSK2020_R01LotList,
		setKSK2020_R01DetailList,
		setKSK2020_R01InspectList,
		setKSK2020_R01LotList,
		setOriginalKSK2020_R01InspectList,
		setOriginalKSK2020_R01LotList,
		setSelectedKSK2020_R01InspectList,
		setSelectedKSK2020_R01LotList,
	]);

	// KSK2010 등에서 전달받은 데이터로 자동 조회
	useEffect(() => {
		
		if (productWorkNavigationData) {
			const orderNo = productWorkNavigationData.productOrderNo
				|| productWorkNavigationData.productWorkNo
				|| '';

			navigationDataRef.current = { productOrderNo: orderNo, productWorkNo: productWorkNavigationData.productWorkNo };

			// 기존: productWorkNo 세팅 → PRD형: productOrderNo 세팅
			setEditKSK2020_R01({ ...editKSK2020_R01!, productOrderNo: orderNo } as KSK2020_R01HeaderDto);
			setProductWorkTrigger(true);
			
			setProductWorkNavigationData(null);
		}
	}, [productWorkNavigationData, setProductWorkNavigationData]);

	// productWorkTrigger true이면 handleFetchLotList를 호출
	useEffect(() => {
		const orderNo = navigationDataRef.current?.productOrderNo || editKSK2020_R01?.productOrderNo || '';
		if (productWorkTrigger && validateString(orderNo)) {
			handleFetchLotList();
			setProductWorkTrigger(false);
		}
	}, [productWorkTrigger]);

	
	useEffect(() => {
		if (company) {
			setKSK2020_R01Filter({ ...KSK2020_R01Filter, labelPrintAuto: company.labelPrintAuto });
		}
	}, [company, setKSK2020_R01Filter]);

	useEffect(() => {
		let isDisposed = false;

		const intervalId = window.setInterval(() => {
			if (isLotCountPollingRef.current || lotCountAdjustmentPendingRef.current !== 0) {
				return;
			}

			const currentEdit = useKSK2020_R01Store.getState().editKSK2020_R01;
			if (!currentEdit || !validateString(currentEdit.workplaceCd)) {
				return;
			}

			const workplaceCd = currentEdit.workplaceCd;
			const adjustmentVersion = lotCountAdjustmentVersionRef.current;
			isLotCountPollingRef.current = true;

			void getKSK2020_R01LotCountOne(workplaceCd)
				.then((response) => {
					if (isDisposed
						|| lotCountAdjustmentPendingRef.current !== 0
						|| lotCountAdjustmentVersionRef.current !== adjustmentVersion) {
						return;
					}

					const latestEdit = useKSK2020_R01Store.getState().editKSK2020_R01;
					if (!latestEdit || latestEdit.workplaceCd !== workplaceCd) {
						return;
					}

					const pendingLotQty = Number(response.data.data?.pendingLotQty) || 0;
					setEditKSK2020_R01({
						...latestEdit,
						plcCount: pendingLotQty,
					});
				})
				.catch((error) => {
					console.error('실적 Count 주기 조회 실패:', error);
				})
				.finally(() => {
					isLotCountPollingRef.current = false;
				});
		}, 20_000);

		return () => {
			isDisposed = true;
			window.clearInterval(intervalId);
		};
	}, [setEditKSK2020_R01]);
	
	return {
		handlePrintClick,
		handleExcelClick,
		// fetchData,
		fetchOne,
		defaultKSK2020_R01HeaderRow,
		defaultKSK2020_R01LotRow,
		defaultKSK2020_R01DetailRow,
		defaultKSK2020_R01InspectRow,
		initContainerData,
		handleWorkResetClick,
		handleDeleteClick,
		handleCreateClick,
		handleSaveClick,
		handleWorkTimeClick,
		handleFetchBomProductList,
		getProductWorkFieldHandlers,
		handleFetchLotList,
		handleFetchProductResult,
		handleLotCountChange,
		handleLotCountResetClick,
		isLotCountResetting,
		handleLotCreateClick,
		handleInspectConfirmClick,
		handleInspectDeleteClick,
	};
}
